export default "__VITE_ASSET__fa4532c3__"